<template>
  <div class="finance-page">
    <div class="finance-section">
      <ulu-finance-revenue />
    </div>
    <div class="finance-section">
      <ulu-finance-kpi />
    </div>
  </div>
</template>

<script>
export default {
  components: {
    "ulu-finance-revenue": () =>
      import(
        "@/components/dashboard/finance/finance_revenue/FinanceRevenue.vue"
      ),
    "ulu-finance-kpi": () =>
      import(
        "@/components/dashboard/finance/finance_kpi/FinanceKpi.vue"
      )
  },
};
</script>

<style scoped>
.finance-page {
  background-color: #f7f7f7;
  min-height: 100vh;
  padding: 24px;
}

.finance-section {
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-bottom: 24px;
  overflow: hidden;
}
</style>
